export default __webpack_public_path__ + "static/media/navBarLogo.2cdee165.svg";